import classNames from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import * as ToasterActionCreators from '../../actions';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import ToasterSvgs from './ToasterSvgs';
import Toast from '../Toast/Toast';
import './Toaster.less';

const noop = () => {};

function Toaster({
    autoClose,
    autoCloseAfter,
    containerClass,
    onAutoClose,
    onClose,
    onCloseClick,
    onContentClick,
    onToastClick,
    position,
    removeToastById,
    toasts,
    type
}) {
    const containerClasses = classNames({
        'toaster': true,
        'is-bottom': position === 'bottom',
        'is-top': position === 'top'
    });

    return (
        <div className={containerClasses}>
            <ToasterSvgs />
            {toasts.map((toast) => { // eslint-disable-line
                const {props} = toast;
                const shouldAutoClose = props.autoClose || autoClose;
                const handleAutoClose = props.onAutoClose || onAutoClose;
                const handleCloseClick = props.onCloseClick || onCloseClick;
                const handleContentClick = props.onContentClick || onContentClick;
                const handleToastClick = props.onToastClick || onToastClick;
                const handleClose = props.onClose || onClose;
                const autoCloseTime = props.autoCloseAfter || autoCloseAfter;
                const toastType = props.type || type;
                const customContainerClass = props.containerClass || containerClass;
                return (
                    <Toast
                        key={`toast-${props.id}`}
                        {...toast.props}
                        autoClose={shouldAutoClose}
                        autoCloseAfter={autoCloseTime}
                        containerClass={customContainerClass}
                        onClose={handleClose}
                        onRemove={removeToastById}
                        onContentClick={handleContentClick}
                        onAutoClose={handleAutoClose}
                        onCloseClick={handleCloseClick}
                        onToastClick={handleToastClick}
                        type={toastType}
                    />
                );
            })}
        </div>
    );
}

Toaster.propTypes = {
    autoClose: PropTypes.bool,
    autoCloseAfter: PropTypes.number,
    containerClass: PropTypes.string,
    position: PropTypes.oneOf(['top', 'bottom']),
    onAutoClose: PropTypes.func,
    onContentClick: PropTypes.func,
    onCloseClick: PropTypes.func,
    onClose: PropTypes.func,
    onToastClick: PropTypes.func,
    type: PropTypes.string,
    id: PropTypes.number
};

Toaster.defaultProps = {
    autoClose: true,
    autoCloseAfter: 5000, // 5 seconds
    containerClass: '',
    position: 'bottom',
    onAutoClose: noop,
    onContentClick: noop,
    onCloseClick: noop,
    onToastClick: noop,
    onClose: noop,
    type: 'default'
};

function mapStateToProps(state) {
    return {
        toasts: state.toasts
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    removeToastById: ToasterActionCreators.removeToastById,
    createToast: ToasterActionCreators.createToast
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Toaster);
